import { FormControl, InputLabel, Select, MenuItem, Stack, Button } from '@material-ui/core';
import { getUsersLeagues, updateUserLeagues } from '../../../api_helper/api';
import getLogo from '../../../utils/getLogo';
import { useContext, useEffect, useState } from 'react';
import SnackbarAlertContext from '../../../context/SnackbarAlertContext';
import { UserProfileContext } from '../../../UserProfileContext';
import ConnectFantasyAccountModal from './ConnectFantasyAccountModal';
import { getUserMessage } from '../../../utils/handleError';

const SelectFantasyLeagueDropdown = ({ selectedFantasyLeague, handleFantasyLeagueChange, isOptionDisabled }) => {
	const snackbarAlertContext = useContext(SnackbarAlertContext);
	const userProfileContext = useContext(UserProfileContext)[0];

	const [fantasyLeagues, setFantasyLeagues] = useState();
	const [isConnectFantasyAccountModalOpen, setIsConnectFantasyAccountModalOpen] = useState(false);

	const updateLeagues = async () => {
		let res = await getUsersLeagues();
		setFantasyLeagues(res.leagues);
	};

	const handleClickRefreshLeagues = async () => {
		try {
			handleFantasyLeagueChange({ target: { value: undefined } });
			setFantasyLeagues(undefined);
			await updateUserLeagues({ userId: userProfileContext._id });
			await updateLeagues();
		} catch (e) {
			snackbarAlertContext.setSnackbarAlert({ msg: getUserMessage(e), severity: 'error' });
		}
	};

	const handleClickConnectFantasyAccountModal = () => {
		setIsConnectFantasyAccountModalOpen(true);
	};

	const handleConnectFantasyAccountSuccess = ({ fantasyPlatform }) => {
		if (fantasyPlatform === 'Fantrax') {
			handleClickRefreshLeagues();
		}
	};

	useEffect(() => {
		updateLeagues();
	}, []);

	const menuItem = (fantasyLeague) => {
		const disabled = isOptionDisabled ? isOptionDisabled(fantasyLeague) : false;

		return (
			<MenuItem key={fantasyLeague._id} value={fantasyLeague} disabled={disabled}>
				<div style={{ display: 'flex', alignItems: 'center' }}>
					<img
						src={getLogo({ api: fantasyLeague.api })}
						style={{ width: '2rem', borderRadius: '0.2rem', marginRight: '0.5rem' }}
					/>
					{fantasyLeague.displayName}
				</div>
			</MenuItem>
		);
	};

	return (
		<>
			<ConnectFantasyAccountModal
				isOpen={isConnectFantasyAccountModalOpen}
				onClose={() => setIsConnectFantasyAccountModalOpen(false)}
				onSuccess={handleConnectFantasyAccountSuccess}
			/>

			<Stack alignItems="start" gap={1}>
				<FormControl fullWidth>
					<InputLabel id="fantasy-league-select-label">Select Fantasy League</InputLabel>
					<Select
						labelId="fantasy-league-select-label"
						label="Select Fantasy League"
						fullWidth
						value={selectedFantasyLeague || ''}
						onChange={handleFantasyLeagueChange}
					>
						{fantasyLeagues ? (
							fantasyLeagues.length ? (
								fantasyLeagues.map((fantasyLeague) => menuItem(fantasyLeague))
							) : (
								<MenuItem disabled={true}>No leagues found</MenuItem>
							)
						) : (
							<MenuItem disabled={true}>Loading...</MenuItem>
						)}
					</Select>
				</FormControl>

				<div>
					<Button onClick={handleClickConnectFantasyAccountModal} color="secondary" variant="contained">
						Connect Fantasy Account
					</Button>

					<Button onClick={handleClickRefreshLeagues} color="secondary" sx={{ ml: 1 }}>
						Refresh Leagues
					</Button>
				</div>
			</Stack>
		</>
	);
};

export default SelectFantasyLeagueDropdown;
